export default {"src":"/_next/static/media/ic_chat_side_menu.f4b3d88c.svg","height":25,"width":33,"blurWidth":0,"blurHeight":0};